const values = [
  {
    icon: 'ri-star-line',
    title: 'Excellence',
    description: 'High standards in programme design, facilitation, learner support and compliance delivery.',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Practical Innovation',
    description: 'Modern learning methods that make training easier to access, apply and measure.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Integrity',
    description: 'Transparent guidance, ethical practice and dependable support through every step.',
  },
  {
    icon: 'ri-team-line',
    title: 'Partnership',
    description: 'Long-term relationships with employers, learners and communities built around shared outcomes.',
  },
];

export default function ValuesSection() {
  return (
    <section className="section-wrap bg-[#f8f9fa]">
      <div className="section-inner">
        <div className="grid lg:grid-cols-[0.8fr_1.2fr] gap-12 lg:gap-16 items-start">
          <div className="reveal-left">
            <p className="section-label">Our Values</p>
            <h2 className="section-heading">What shapes every learning experience</h2>
            <p className="section-body">
              Sylman is built around outcomes that matter: recognised skills, confident learners,
              compliant organisations and training that turns potential into performance.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-5 reveal-children">
            {values.map(value => (
              <div key={value.title} className="card group p-6">
                <div className="icon-box mb-5">
                  <i className={value.icon} />
                </div>
                <h3 className="font-sans text-base font-semibold text-[#111111] mb-2">{value.title}</h3>
                <p className="text-sm leading-relaxed text-[#6b7280]">{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="dark-panel mt-14 p-8 md:p-12 text-center reveal">
          <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '24px 24px' }} />
          <div className="relative z-10 mx-auto max-w-4xl">
            <p className="section-label justify-center" style={{ color: '#5EC97A' }}>Our commitment to you</p>
            <h3 className="font-serif text-2xl md:text-4xl leading-tight !text-white">
              Every programme should leave people more capable than when they arrived.
            </h3>
            <p className="mx-auto mt-5 max-w-3xl text-base leading-relaxed text-white/75">
              When you choose Sylman Academy, you choose a partner committed to clear guidance,
              credible training and measurable growth for your people.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
